import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
import { Text } from '@mantine/core';

import logo from '@assets/images/tc-gymnasium-logo.png';
import PasswordForm from './PasswordForm';

import './index.scss';

export default function Code() {
  const { id } = useParams();
  const [codeData, setCodeData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios
      .get(`/verify-code/${id}/`)
      .then(({ data }) => {
        setCodeData(data.response[0]);
      })
      .catch((err) => {
        setError(typeof err === 'string' ? err : 'Invalid or expired code.');
      });
  }, [id]);

  if (error) {
    return (
      <div className="login-page">
        <div className="login">
          <img src={logo} alt="T&C's Gymnasium" />
          <Text c="var(--brand-brick)" mt="md" ta="center">
            {error}
          </Text>
          <Link
            className="login-secondary-link"
            to="/admin"
            style={{ marginTop: 16, display: 'block', textAlign: 'center' }}
          >
            Back to login
          </Link>
        </div>
      </div>
    );
  }

  if (!codeData) {
    return (
      <div className="login-page">
        <div className="login">
          <img src={logo} alt="T&C's Gymnasium" />
          <p className="login-tagline">Loading…</p>
        </div>
      </div>
    );
  }

  if (codeData.variety !== 1 && codeData.variety !== 2) {
    return (
      <div className="login-page">
        <div className="login">
          <Text>Unsupported code type.</Text>
        </div>
      </div>
    );
  }

  return (
    <div className="login-page">
      <div className="login">
        <img src={logo} alt="T&C's Gymnasium" />
        <p className="login-tagline">Create a password for {codeData.email}</p>
        <div className="login-form">
          <PasswordForm
            additionalReqData={{
              remote_code_id: codeData.id,
              admin_id: codeData.admin_id,
              athlete_id: codeData.athlete_id,
            }}
          />
        </div>
      </div>
    </div>
  );
}
